import React, { useContext } from "react";
import ParameterContext from "../context/parameter/parameterContext";

import ReactPaginate from "react-paginate";
import { IoCaretBackSharp, IoCaretForwardSharp } from "react-icons/io5";

const Pagination = ({ pages }) => {
  const { page, setPage } = useContext(ParameterContext);
  const handlePageClick = (e) => {
    setPage(e.selected);
  };
  const pageCount = pages;
  return (
    <ReactPaginate
      previousLabel={<IoCaretBackSharp />}
      nextLabel={<IoCaretForwardSharp />}
      breakLabel={". . ."}
      pageCount={pageCount}
      forcePage={page}
      marginPagesDisplayed={1}
      pageRangeDisplayed={1}
      onPageChange={handlePageClick}
      containerClassName="Pagination__container"
      activeClassName="Pagination__active"
      pageClassName="Pagination__list"
      previousClassName="Pagination__marginpages"
      nextClassName="Pagination__marginpages"
      breakClassName="Pagination__breakpages"
      pageLinkClassName="Pagination__refpages"
      previousLinkClassName="Pagination__refpages"
      nextLinkClassName="Pagination__refpages"
      breakLinkClassName="Pagination__refpages"
      activeLinkClassName="Pagination__active"
      disabledClassName="Pagination__disabled"
    />
  );
};

export default Pagination;
